import { EVENT_REPORT_STATUS_CHANGE } from "constants.js";

export class ReportScopeActions {
	constructor(reportScope, reportHelper) {
		this.reportScope = reportScope;
		this.reportHelper = reportHelper;
	}

	saveReport(updates, report = this.reportScope.report) {
		return this.reportHelper.saveReport(this.formId, updates, report);
	}

	submit(report = this.reportScope.report) {
		return this.handleStatusChange(
			this.reportHelper.submit(this.formId, report)
		);
	}

	withdraw(report = this.reportScope.report) {
		return this.handleStatusChange(
			this.reportHelper.withdraw(this.formId, report)
		);
	}

	delete(report = this.reportScope.report) {
		return this.handleStatusChange(
			this.reportHelper.delete(this.formId, report)
		);
	}

	restore(report = this.reportScope.report) {
		return this.handleStatusChange(
			this.reportHelper.restore(this.formId, report)
		);
	}

	get formId() {
		return this.reportScope.form.Id;
	}

	handleStatusChange(promise) {
		return promise
			.then(report => {
				this.reportScope.events.trigger(EVENT_REPORT_STATUS_CHANGE, report);
				return report;
			})
			.catch(err => {
				if(err?.Data?.Rules) {
					this.reportScope.events.trigger(EVENT_REPORT_STATUS_CHANGE, err.Data);
				}

				throw err;
			});
	}
}
